import React, { useContext, useMemo } from 'react';
import { Drawer } from 'antd';
import { DrawerContext } from '@/contexts/DrawerContext';
import type { DrawerContextType } from '@/contexts/DrawerContext';

const GlobalDrawer: React.FC = () => {
  const context = useContext(DrawerContext) as DrawerContextType;
  const { isOpen, config, closeDrawer } = context;

  // 使用 useMemo 优化性能，避免不必要的重新渲染
  const drawerProps = useMemo(() => {
    if (!config) return null;

    return {
      title: config.title,
      placement: config.placement || 'right',
      width: config.width || 720,
      onClose: closeDrawer,
      open: isOpen,
      destroyOnClose: true,
      maskClosable: config.maskClosable || false,
      closable: config.closable !== false,
      keyboard: config.keyboard !== false,
      footer: config.footer,
      zIndex: config.zIndex || 1000,
      className: 'global-drawer',
      rootClassName: 'global-drawer-root',
      styles: {
        body: {
          pointerEvents: 'auto' as const,
          padding: '24px',
        },
        header: {
          borderBottom: '1px solid var(--border-primary)',
          padding: '16px 24px',
        },
        footer: {
          borderTop: '1px solid var(--border-primary)',
          padding: '12px 24px',
        },
      },
    };
  }, [config, isOpen, closeDrawer]);

  if (!config || !drawerProps) return null;

  return (
    <Drawer {...drawerProps}>
      <div style={{ position: 'relative', zIndex: 10, height: '100%' }}>
        {config.content}
      </div>
    </Drawer>
  );
};

export default GlobalDrawer;

